import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-call-for-workshops25',
  templateUrl: './call-for-workshops.component.html',
  styleUrls: ['./call-for-workshops.component.css']
})
export class CallForWorkshopsComponent25 implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
